import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RequestService {
  private apiUrl = `${environment.apiUrl}/api/requests`;

  constructor(private http: HttpClient) {}

  getRequests(type?: string): Observable<any> {
    let params = {};
    if (type) {
      params = { params: { type } };
    }
    return this.http.get(this.apiUrl, params);
  }

  getRequestById(id: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`);
  }

  createRequest(request: any): Observable<any> {
    return this.http.post(`${this.apiUrl}`, request);
  }

  updateRequest(id: string, request: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, request);
  }

  deleteRequest(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
}
